import {
  sendChatMessageMockHandler,
  sendFeedbackMockHandler,
} from '@/features/bhanzu-buddy/api/chat';
import { getChatHistoryMockHandler } from '@/features/bhanzu-buddy/api/chat-history';

export const bhanzuBuddyHandlers = [
  sendChatMessageMockHandler,
  sendFeedbackMockHandler,
  getChatHistoryMockHandler,
];
